module.exports = __webpack_public_path__ + "src/assets/images/unlock-icon-18.8d108d9530dcdabcfd52250794594b61.png";